export enum ActCellIconType {
  Menu = 'menu',
  Info = 'info',
}
